import { render, staticRenderFns } from "./ErrorMessages.vue?vue&type=template&id=9df12ff2&"
import script from "./ErrorMessages.vue?vue&type=script&lang=ts&"
export * from "./ErrorMessages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports